// FlowPath_style.js
import { getColor } from '../../StyleBase_style.js';
import { zoom } from '../../zoomUtils.js';

export const flowPathStyles = {
  container: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
    top: 0,
    left: 0,
    zIndex: 1,
    overflow: 'visible'
  },

  path: {
    stroke: getColor('primaryAccent'),
    strokeOpacity: 0.5,
    strokeWidth: zoom('3px')
  }
};

export const getFlowPathStyles = () => {
  return {
    container: flowPathStyles.container,
    path: flowPathStyles.path
  };
};